/* eslint-disable @typescript-eslint/no-explicit-any */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { fetchAssetGroupSearchHistoryService, updateWellSearchHistoryService } from '../../features/navigation/SearchHistoryService';
import { UpdateWellSearchHistoryParams } from '../../models/UpdateWellSearchHistoryParamsModel';
import { WellSearchObjectModel } from '../../models/WellSearchModel';

interface TasksState {
    searchHistory: WellSearchObjectModel[] | null;
    loading: boolean;
    error: string | null;
}
const initialState: TasksState = {
    searchHistory: null,
    loading: false,
    error: null,
};

export const updateWellSearchHistory: any = createAsyncThunk('SearchHistorySlice/updateWellSearchHistory', async (updateWellSearchHistoryParams: UpdateWellSearchHistoryParams
) => {
    const response = await updateWellSearchHistoryService(updateWellSearchHistoryParams);
    return response;
});

export const fetchAssetGroupSearchHistory: any = createAsyncThunk('SearchHistorySlice/fetchAssetGroupSearchHistory', async (
) => {
    const response = await fetchAssetGroupSearchHistoryService();
    return response;
});

const SearchHistorySlice = createSlice({
    name: 'SearchHistorySlice',
    initialState,
    reducers: {
        resetSearchHistoryState: (state) => {
            state.searchHistory = null;
            state.error = null;
            state.loading = false;

        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAssetGroupSearchHistory.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchAssetGroupSearchHistory.fulfilled, (state, action) => {
                state.loading = false;
                const data = action.payload.result?.value;
                state.searchHistory = data;
            })
            .addCase(fetchAssetGroupSearchHistory.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message ?? 'Failed to fetch search history';
            });
    },
});

export const { resetSearchHistoryState } = SearchHistorySlice.actions;
export default SearchHistorySlice.reducer;
